import {Validator} from './validator';

export class HubSpotValidator implements Validator {

    async validate(validationContext: any) {
        try {
            const hsFormSubmitBtn = validationContext.hubSpotView.getFromHSFrame('input[type="submit"].hs-button') as HTMLElement;
            hsFormSubmitBtn.click();
            let isFormValid = true;
            const hubSpotApi = validationContext.hubSpotApi;

            const fields = hubSpotApi._getState().fields;
            for (const property in fields) {
                if (fields.hasOwnProperty(property)) {
                    const field = fields[property];
                    const errors = field.errors;
                    if (field.shown && errors && errors.length > 0) {
                        isFormValid = false;
                        break;
                    }
                }
            }

            return Promise.resolve(isFormValid);
        } catch (e) {
            // TODO: Move to common css file
            const styleTag = document.createElement('style');
            styleTag.innerHTML = '#df-card-container .input > label.error { display: block !important; }';

            if (document.head) {
                document.head.appendChild(styleTag);
            }
            return Promise.resolve(false);
        }
    }

}
